import { useTranslation } from "react-i18next";
import { DeviceFC } from "types";

import { ProductCardFooterItem } from "@/components/Layout/BaseLayouts/ProductCard/ProductCardFooterItem";
import { ExtendedSimCardDetail } from "@/hooks/useExtendedSims";
import {
  formatFlatMobileRoamingInGb,
  formatRoamingTotalInGb,
  formatRoamingUsageInGb,
  getFirstOfSortedRoaming,
  isZone1,
} from "@/utils/deviceUtils";

export const RoamingUsage: DeviceFC = ({
  device,
}: {
  device: ExtendedSimCardDetail;
}) => {
  // We want only the most important of maximum three roaming infos displayed here.
  const roamingInfo = getFirstOfSortedRoaming(device);
  const hasRoaming = (roamingInfo?.initialVolume || 0) > 0;
  const { t } = useTranslation();

  // Zone 1 displays in GB, Zone 2/3 display in MB
  const useGB = isZone1(roamingInfo?.usageZone);
  const formatRemainingInGb = roamingInfo?.includedInService
    ? formatFlatMobileRoamingInGb
    : formatRoamingUsageInGb;
  const formatAvailableInGb = roamingInfo?.includedInService
    ? formatFlatMobileRoamingInGb
    : formatRoamingTotalInGb;
  const available = roamingInfo?.initialVolume || 0;
  // Remaining capacity (full when unused), matching the roaming tab's
  // "X of Y available/verfügbar" framing — not spent/used.
  const remaining = roamingInfo?.remainingVolume || 0;

  if (!hasRoaming) {
    return null;
  }

  return (
    <ProductCardFooterItem
      variant="progressbar"
      label={t("cockpit.managementTile.roaming.showOption.active.dataUsage")}
      value={remaining}
      max={available}
      description={t(
        useGB
          ? "layout.tiles.activeSim.roamingUsageGB"
          : "layout.tiles.activeSim.roamingUsage",
        {
          remaining: useGB ? formatRemainingInGb(remaining) : remaining,
          available: useGB ? formatAvailableInGb(available) : available,
        },
      )}
    />
  );
};
